import { Component, OnInit } from '@angular/core';
import { DialogService } from '../service/dialog-service';
import { BehaviorModelChangeService } from '../service/behavior-model-change.service.service';
import { ApplicantService } from '../service/applicant.service';
import { ComponentBase } from '../base/component-base';
import { Configuration } from '../configuration';
import { ToastrService } from 'ngx-toastr';
import { CookiesLocalService } from '../service/cookies-local.service';
import { IApplicantExamination } from '../model/IApplicantExamination';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends ComponentBase implements OnInit  {
  applicantProgrammeLocal: [];
  examinationData: IApplicantExamination[];

  constructor(private router: Router, applicantService: ApplicantService, cookieLocal: CookiesLocalService
    ,         private toastr: ToastrService
    ,         private dialogService: DialogService,
              behaviorModelChangeService: BehaviorModelChangeService) {

    super(applicantService, cookieLocal, behaviorModelChangeService);
    const isHelpShown = localStorage.getItem(Configuration.localStorageData.hasReadHelp);


    if (!this.isPostgraduateStudent()) {
      if (!isHelpShown) {


              this.dialogService.openAppTourDialog('')
              .afterClosed().subscribe(res => {
                if (res) {
                  this.toastr.info('Thank you for choosing UMaT', 'Welcome to UMaT Admissions Portal!');
                  localStorage.setItem(Configuration.localStorageData.hasReadHelp, 'false');
                }
              });

            }
    }





     }

  ngOnInit() {
    this.applicantData = this.cookieLocal.getApplicantData();

    this.getApplicantAllData();

  }

  onStart() {
    this.router.navigate(['/applicant/info/notices']);
  }

}
